import thumbnail from '../asset/Thumbnail.png';
import logo from '../asset/EAS-logo.png';
import gallery01 from '../asset/img-1.jpg';
import gallery02 from '../asset/img-2.jpg';
import gallery04 from '../asset/img-4.png';
import setting_icon from '../asset/setting-icon.png';
import setting_menu_icon from '../asset/setting-icon.png';
import user from '../asset/user.png';

export default {
    thumbnail,
    logo,
    gallery01,
    gallery02,
    gallery04,
    setting_icon,
    setting_menu_icon,
    user
};